import { Category } from '@app/models/_index';
import { Observable, catchError, throwError } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WordpressPaging } from '@app/enums/_index';
import { VideoInterface } from '@app/interfaces/video.interface';
import { getCacheBustedParams } from '@app/utilities/cacheBustedHttpParams.utilities';
import { environment } from '@environments/environment';
import { ErrorHandlerService } from '../shared/error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class WordpressVideosService extends ErrorHandlerService {
  private wpvideosPageURL = `${environment.cms.url}/wp-json/wp/v2/videos`;
  private wpvideosCategoryURL = `${environment.cms.url}/wp-json/wp/v2/categories`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Returns the Featured videos from wordpress API
   * @returns Featured videos observable response
   *  TODO: Need to remove this page and per page and make them as parameters.
   */
  getWpFeaturedVideos(): Observable<VideoInterface[]> {
    const videoURLParams = getCacheBustedParams()
      .append(WordpressPaging.ORDER_BY_KEY, WordpressPaging.ORDER_BY_VALUE)
      .append(WordpressPaging.ORDER_KEY, WordpressPaging.ORDER_VALUE)
      .append(WordpressPaging.PER_PAGE_KEY, WordpressPaging.PER_PAGE_VALUE);

    return this.http
      .get<VideoInterface[]>(`${this.wpvideosPageURL}`, { params: videoURLParams })
      .pipe(
        catchError((err) => {
          console.log(`Service error has occurred`, err);
          return throwError(() => new Error(err));
        }),
        catchError(this.handleError<any[]>('getWpFeaturedVideos', []))
      );
  }

  /**
   * Return video categories as Observable collection of video categories
   * @returns - Observable array of Category models
   */
  getWpVideoCategories(): Observable<Category[]> {
    return this.http.get<Category[]>(this.wpvideosCategoryURL).pipe(
      catchError((err) => {
        console.log(`Service error has occurred`, err);
        return throwError(() => new Error(err));
      }),
      catchError(this.handleError<any[]>('getWpFeaturedVideos', []))
    );
  }

  /**
   * Return get recommended videos as Observable collection of video
   * Slug video slug reference to filter
   * @returns Observable array of videos
   * TODO: Need to remove this page and per page and make them as parameters.
   */
  getWpRecommendedVideos(): Observable<VideoInterface[]> {
    const videoURLParams = getCacheBustedParams()
      .append(WordpressPaging.ORDER_BY_KEY, WordpressPaging.ORDER_BY_VALUE)
      .append(WordpressPaging.ORDER_KEY, WordpressPaging.ORDER_VALUE)
      .append(WordpressPaging.PER_PAGE_KEY, WordpressPaging.PER_PAGE_VALUE);

    return this.http
      .get<VideoInterface[]>(`${this.wpvideosPageURL}`, { params: videoURLParams })
      .pipe(
        catchError((err) => {
          console.log(`Service error has occurred`, err);
          return throwError(() => new Error(err));
        }),
        catchError(this.handleError<any[]>('getWpRecommendedVideos', []))
      );
  }

  /**
   * Generic get videos by slug
   * @param id - video slug id reference to filter
   * @returns - Observable array of videos by given category id
   */
  getWpVideosBySlugId(id: number): Observable<VideoInterface[]> {
    return this.http.get<VideoInterface[]>(`${this.wpvideosPageURL}?categories=${id}`).pipe(
      catchError((err) => {
        console.log(`Service error has occurred`, err);
        return throwError(() => new Error(err));
      }),
      catchError(this.handleError<any[]>('getWpVideosBySlugId', []))
    );
  }
}
